import React, { useState, useContext } from 'react';
import Swal from "sweetalert2";
import JsonView from 'react18-json-view';
import withReactContent from 'sweetalert2-react-content';
import './ThreatMetrix.css';
import { API_URL } from '../../../constants';
import { TabContext } from '../../home/TabProvider';
import 'react18-json-view/src/style.css';
import { LoadingButton } from '@mui/lab';
import { TextField, Stack, Container, Typography } from '@mui/material';
import QRCode from 'qrcode'

function ThreatMetrix() {

    const { sharedData } = useContext(TabContext);
    const MySwal = withReactContent(Swal);
    const [policy, setPolicy] = useState('');
    const [ipAddress, setIpAddress] = useState('');
    const [email, setEmail] = useState(sharedData?.eimpData?.email || '');
    const [telephone, setTelephone] = useState(sharedData?.eimpData?.phone || '');
    const [countryCode, setCountryCode] = useState(sharedData?.eimpData?.countryCode || '1');
    const [firstName, setFirstName] = useState(sharedData?.eimpData?.firstName || '');
    const [lastName, setLastName] = useState(sharedData?.eimpData?.lastName || '');
    const [streetAddress, setStreetAddress] = useState(sharedData?.eimpData?.address?.addressLineOne || '');
    const [city, setCity] = useState(sharedData?.eimpData?.address?.city || '');
    const [state, setState] = useState(sharedData?.eimpData?.address?.provinceState || '');
    const [zipCode, setZipCode] = useState(sharedData?.eimpData?.address?.zipPostalCode || '');
    const [dob, setDob] = useState(sharedData?.eimpData?.dob || '');
    const [nationalIdNumber, setNationalIdNumber] = useState('');
    const [nationalIdType, setNationalIdType] = useState('');
    const [customAttribute1, setCustomAttribute1] = useState('');
    const [withSessionLoading, setWithSessionLoading] = useState(false);
    const [withoutSessionLoading, setWithoutSessionLoading] = useState(false);

    const imageConfig = {
        imageUrl: 'https://myoptum.optum.com/content/dam/hsid/HSID_Logo.png',
        imageWidth: 150,
        imageHeight: 30,
    }

    const handleButtonClick = () => {
        queryTmxSession(`${API_URL}/tmx/profile-query`, setWithSessionLoading, true);
    };

    const handleWithoutSessionClick = () => {
        queryTmxSession(`${API_URL}/tmx/profile-query-without-session`, setWithoutSessionLoading, true);
    }

    const handleSignupClick = () => {
        queryTmxSession( `${API_URL}/tmx/profile-query`, setWithSessionLoading);
    }

    const registrationFailed = `<div style="text-align: left; font-size: 16px; color: #333;">
        <p style="margin-bottom: 20px;">(ERROR: 20001) Registration Failed.</p>
        <p style="margin-bottom: 20px; font-size: 11px; color: #333;">We are unable to proceed with the registration. Please contact suport #1-888-878-2135 M-F 7 a.m to 7 p.m ET</p>
    </div>`;

    const registrationSuccess = `<div style="display: flex; justify-content: space-between;">
        <div style="text-align: left; font-size: 16px; color: #333; flex: 1;">
            <p style="margin-bottom: 20px;">Your Account has been created.</p>
            <p style="margin-bottom: 20px; font-size: 11px; color: #333;">Now you can use your <b>HealthSafe ID</b> to access your helath and wellness benefits</p>
        </div>
        <div style="text-align: left; font-size: 12px; color: #333; flex: 1;">
            <p style="margin-bottom: 20px; font-size: 11px; font-wight:bold; color: #333;">Account Detail</p>
            <p style="margin-bottom: 20px; font-size: 11px; color: #333;">Email Address: <b>${email}</b></p>
            <p style="margin-bottom: 20px; font-size: 11px; color: #333;">Phone Number: <b>${telephone}</b></p>
        </div>
    </div>`;

    const optedOutError = `<div style="text-align: left; font-size: 16px; color: #333;">
        <p style="margin-bottom: 20px;">(ERROR: 20004) Opted out of Document Identity Verification</p>
        <p style="margin-bottom: 20px; font-size: 11px; color: #333;">We are unable to proceed with the registration. Please contact suport #1-888-878-2135 M-F 7 a.m to 7 p.m ET</p>
    </div>`;

    const documentVerificationError = `<div style="text-align: left; font-size: 16px; color: #333;">
        <p style="margin-bottom: 20px;">(ERROR: 20005) Failed Document Identity Verification</p>
        <p style="margin-bottom: 20px; font-size: 11px; color: #333;">We are unable to proceed with the registration. Please contact suport #1-888-878-2135 M-F 7 a.m to 7 p.m ET</p>
    </div>`;

    const initialScreen = `<div class="auto">
            <p class='heading'> Identity verification required </p>
            <div class="info">
                <p>You need to complete identity verification to proceed with online registration. You will need the following:</p>
                <ul>
                    <li>Use a <b>phone or tablet</b> to complete identity verification</li>
                    <li>You will be taking a <b>selfie</b> as part of the process</li>
                    <li><b>Government issued ID card</b> (eg, driver's license, passport, state-issued ID)</li>
                </ul>
                <div style="width:auto: margin:auto">
                    <img style="width:250px; height:250px; margin-right:auto" src="INSERT_IMAGE_HERE" />
                </div>
                <p>You will need to complete identity verification on a phone or tablet</p>
                <p>I don't wish to proceed with online identity verification</p>
                <p>We won't be able to create your account at this point</p>
            </div>
        </div>`;

    const cancelTransation = (transcationId) => {
        fetch(`${API_URL}/api/idverse/transaction/cancel/${transcationId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .catch(error => console.error(error));
    }

    const checkVerificationStatus = (id) => {
        console.info('Checking verification status', id);
        fetch(`/api/verified-id/request-status/${id}`)
        .then((response) => {
            if (!response.ok) throw new Error(response.statusText);
            return response.json();
        })
        .then((data) => {
            let sweetAlert = null;

            if (previousStatus === data.status) {
                setTimeout(() => checkVerificationStatus(id), 4000);
                return;
            }
            setPreviousStatus(data.status);

            switch (data.status) {
                case 'verification_request_created':
                case 'issuance_request_created':
                    setTimeout(() => checkVerificationStatus(id), 4000);
                    break;
                case 'request_completed':
                case 'presentation_verified':
                case 'issuance_successful':
                case 'issuance_error':
                    swalAlert?.close();
                    sweetAlert = Swal.fire({
                        html: data.message,
                        confirmButtonText: "Cancel"
                    })
                    break;
                default:
                    swalAlert?.close();
                    sweetAlert = Swal.fire({
                        html: data.message,
                        confirmButtonText: "Cancel"
                    })
                    setTimeout(() => checkVerificationStatus(id), 4000);
                    break;
            }
            setSwalAlert(sweetAlert);
        })
        .catch((error) => {
            console.error(error);
        });
    };

    const handleQueryResponse = (data) => {
        if (data.request_result === 'success') {

            Swal.fire({
                icon: "success",
                title: policy,
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: "See Details",
                denyButtonText: `Skip`
              }).then((result) => {
                if (result.isConfirmed) {
                    MySwal.fire({
                        title: "ThreatMetrix Response",
                        width: 800,
                        html: <JsonView src={data} />
                    })
                }
              });
        }
        else {
            Swal.fire({
                title: "Error Details:- " + data.error_detail,
                html: data.request_result,
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: "See Details",
                denyButtonText: `Skip`
              }).then((result) => {
                if (result.isConfirmed) {
                  Swal.fire(JSON.stringify(data), "", "error");
                }
              });
        }
    }

    const handleSignupResponse = (data) => {
        if (data.request_result === 'success' && data.review_status === 'pass') {
            MySwal.fire({
                ...imageConfig,
                html: registrationSuccess,
                confirmButtonText: "Continue",
            });
        }
        else if (data.request_result === 'success' && (data.review_status === 'challenge' || data.review_status === 'review')) {
            const authSelectionID = data.auth_selection_id_secure;
            if (!authSelectionID) {
                console.error("Authentication Selection ID is missing in the response.");
            }
            const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
            const baseUrl = isLocalhost ? 'https://staging.optum.idkit.co' : 'https://verify.healthsafe-id.com';
            
            QRCode.toDataURL(`${baseUrl}/${authSelectionID}`)
            .then(url => {
                MySwal.fire({
                    ...imageConfig,
                    html: initialScreen.replace('INSERT_IMAGE_HERE', url),
                    confirmButtonText: "Continue",
                    denyButtonText: `I don't wish to proceed`,
                    showDenyButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showCancelButton: false
                });

                checkVerificationStatus(authSelectionID);
            })
            .then((resp) => {
                if (resp.isConfirmed) {
                    MySwal.close();
                    MySwal.fire({
                        ...imageConfig,
                        html: optedOutError,
                        icon: "warning",
                    }).then(() => {
                        MySwal.close();
                    });
                }
                else if (resp.isDenied) {
                    MySwal.close();
                    MySwal.fire({
                        ...imageConfig,
                        html: optedOutError,
                        icon: "warning",
                    }).then(() => {
                        MySwal.close();
                        cancelTransation(authSelectionID);
                    });
                }
            })
            .catch(err => {
                console.error("Error Creating QR Code", err)
            });
        }
        else if (data.request_result === 'success' && data.review_status === 'reject') {
            MySwal.fire({
                ...imageConfig,
                html: registrationFailed,
                confirmButtonText: "Okay",
            })
        }
        else {
            Swal.fire({
                ...imageConfig,
                title: "Error Details:- " + data.error_detail,
                html: data.request_result,
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: "See Details",
                denyButtonText: `Skip`
                }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire(JSON.stringify(data), "", "error");
                }
            });
        }
    }

    const checkRequestStatus = (requestId) => {
        console.info('Checking transaction status', requestId);
        fetch(`/api/tmx/status/${requestId}`)
        .then((response) => {
            if (!response.ok) throw new Error(response.statusText);
            return response.json();
        })
        .then((response) => {
            let requestCompleted = false;
            response.request_id_activities.forEach((activity) => {
                if (activity === '_CHALLENGE_PASSED') {
                    requestCompleted = true;
                    MySwal.fire({
                        ...imageConfig,
                        html: registrationSuccess,
                        confirmButtonText: "Continue",
                    });
                } else if (activity === '_CHALLENGE_FAILED') {
                    requestCompleted = true;
                    Swal.fire({
                        ...imageConfig,
                        html: documentVerificationError,
                        confirmButtonText: 'OK',
                    });
                }
                else if (activity === 'Rejected: Non Fraud') {
                    requestCompleted = true;
                    Swal.fire({
                        ...imageConfig,
                        text: 'Verification failed.',
                        confirmButtonText: 'OK',
                    });
                }
            });
            if (!requestCompleted) {
                console.info('Request not completed yet, checking again in 6 seconds');
                setTimeout(() => checkRequestStatus(requestId), 6000);
            } 
        })
        .catch((error) => {
            console.error(error);
        });
    };

    const queryTmxSession = (API_URL_QUERY, loadingFunction, isQuery = false) => {

        loadingFunction(true);
        const policy = document.getElementById('policyInput').value;
        const ipAddress = document.getElementById('ipAddressInput').value;
        const email = document.getElementById('emailInput').value;
        const telephone = document.getElementById('telephoneInput').value;
        const countryCode = document.getElementById('countryCodeInput')?.value || '';
        const firstName = document.getElementById('firstNameInput').value;
        const lastName = document.getElementById('lastNameInput').value;
        const streetAddress = document.getElementById('streetAddressInput').value;
        const city = document.getElementById('cityInput').value;
        const state = document.getElementById('stateInput').value;
        const zipCode = document.getElementById('zipCodeInput').value;
        const dob = document.getElementById('dobInput').value;
        const nationalIdNumber = document.getElementById('nationalIdNumberInput').value;
        const nationalIdType = document.getElementById('nationalIdTypeInput').value;
        const customAttribute1 = document.getElementById('customAttribute1').value;

        const requestData = {
            policy,
            ipAddress,
            email,
            telephone,
            countryCode,
            firstName,
            lastName,
            address: {
                streetAddress,
                city,
                state,
                zipCode
            },
            dob,
            customAttribute1,
            nationalIdNumber,
            nationalIdType
        };

        fetch(API_URL_QUERY, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData)
        })
        .then(response => response.json())
        .then(data => {
            loadingFunction(false);
            if (isQuery) 
                handleQueryResponse(data);
            else
                handleSignupResponse(data);
        })
        .catch(error => console.error(error));

    }

    return (
        <Container className="container">
            <Typography variant="h6" component="h6">
                ThreatMetrix 
            </Typography>
            <Stack spacing={2}>
                <TextField
                    label="Policy"
                    placeholder="Policy"
                    id="policyInput"
                    value={policy}
                    onChange={(event) => setPolicy(event.target.value)}
                />
                <TextField
                    label="IP Address"
                    placeholder="IP Address"
                    id="ipAddressInput"
                    value={ipAddress}
                    onChange={(event) => setIpAddress(event.target.value)}
                />
                <TextField
                    label="Email"
                    placeholder="Email"
                    id="emailInput"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                />
                <TextField
                    label="Country Code"
                    placeholder="Country Code"
                    id="countryCodeInput"
                    value={countryCode}
                    onChange={(event) => setCountryCode(event.target.value)}
                />
                <TextField
                    label="Telephone"
                    placeholder="Telephone"
                    id="telephoneInput"
                    value={telephone}
                    onChange={(event) => setTelephone(event.target.value)}
                />
                <TextField
                    label="First Name"
                    placeholder="First Name"
                    id="firstNameInput"
                    value={firstName}
                    onChange={(event) => setFirstName(event.target.value)}
                />
                <TextField
                    label="Last Name"
                    placeholder="Last Name"
                    id="lastNameInput"
                    value={lastName}
                    onChange={(event) => setLastName(event.target.value)}
                />
                <TextField
                    label="Street Address"
                    placeholder="Street Address"
                    id="streetAddressInput"
                    value={streetAddress}
                    onChange={(event) => setStreetAddress(event.target.value)}
                />
                <TextField
                    label="City"
                    placeholder="City"
                    id="cityInput"
                    value={city}
                    onChange={(event) => setCity(event.target.value)}
                />
                <TextField
                    label="State"
                    placeholder="State"
                    id="stateInput"
                    value={state}
                    onChange={(event) => setState(event.target.value)}
                />
                <TextField
                    label="Zip Code"
                    placeholder="Zip Code"
                    id="zipCodeInput"
                    value={zipCode}
                    onChange={(event) => setZipCode(event.target.value)}
                />
                <TextField
                    label="Date of Birth"
                    placeholder="Date of Birth"
                    id="dobInput"
                    value={dob}
                    onChange={(event) => setDob(event.target.value)}
                />
                <TextField
                    label="Custom Attribute 1"
                    placeholder="Custom Attribute 1"
                    id="customAttribute1"
                    value={customAttribute1}
                    onChange={(event) => setCustomAttribute1(event.target.value)}
                />
                <TextField
                    label="National ID Number"
                    placeholder="National ID Number"
                    id="nationalIdNumberInput"
                    value={nationalIdNumber}
                    onChange={(event) => setNationalIdNumber(event.target.value)}
                />
                <TextField
                    label="National ID Type"
                    placeholder="National ID Type"
                    id="nationalIdTypeInput"
                    value={nationalIdType}
                    onChange={(event) => setNationalIdType(event.target.value)}
                />
                <Stack direction="row" spacing={2}>
                    <LoadingButton
                        size="small"
                        loading={withSessionLoading}
                        onClick={handleButtonClick}
                        loadingPosition="center"
                        variant="contained">
                        Query ThreatMetrix
                    </LoadingButton>
                    <LoadingButton
                        size="small"
                        loading={withoutSessionLoading}
                        onClick={handleWithoutSessionClick}
                        loadingPosition="center"
                        variant="contained">
                        Query TMX without session
                    </LoadingButton>
                    <LoadingButton
                        size="small"
                        loading={withSessionLoading}
                        onClick={handleSignupClick}
                        loadingPosition="center"
                        variant="contained">
                        Signup
                    </LoadingButton>
                </Stack>
            </Stack>
        </Container>
    );
}

export default ThreatMetrix;

